export const CASPER_ONBOARDING_SKIPPED_PREFIX = "nextmoca:casper:onboarding-skipped";

export function onboardingTaskStorageId(task = {}) {
  if (task.id) return String(task.id);
  const provider = task.provider || task.provider_label || "provider";
  const requiredEnv = task.required_env || task.required_envs?.[0] || "credential";
  return `${provider}:${requiredEnv}`;
}

export function getPendingOnboardingTasks(status, skippedTaskIds = []) {
  const skipped = new Set((skippedTaskIds || []).map(String));
  return (status?.tasks || []).filter((task) => {
    if (task?.status === "completed") return false;
    if (task?.blocks_launch) return true;
    return !skipped.has(onboardingTaskStorageId(task));
  });
}

export function getAllPendingOnboardingTasks(status) {
  return (status?.tasks || []).filter((task) => task?.status !== "completed");
}

export function getReviewableOnboardingTasks(status, reviewedTaskIds = []) {
  const reviewed = new Set((reviewedTaskIds || []).map(String));
  return getAllPendingOnboardingTasks(status).filter((task) => (
    !reviewed.has(onboardingTaskStorageId(task))
  ));
}

export function interpretOnboardingKeyReply(value = "") {
  const raw = String(value || "").trim();
  const text = raw.toLowerCase();
  if (!raw) return { action: "empty" };
  const skipPhrases = [
    "skip",
    "skip it",
    "skip for now",
    "later",
    "do later",
    "do this later",
    "not now",
    "no",
  ];
  if (skipPhrases.includes(text)) {
    return { action: "skip" };
  }
  return { action: "save", secret: raw };
}

export function isCasperSetupPrompt(value = "") {
  const text = String(value || "").toLowerCase().trim();
  if (!text) return false;
  const explicitSetupAssistantPattern = /\b(open|show|continue|resume|start|finish|review|check)\b.*\b(casper\s+)?(setup|setup center|setup assistant|onboarding|onboard|configuration)\b/;
  const explicitPendingSetupPattern = /\b(show|list|review|check|what|which)\b.*\b(pending|missing|remaining)\b.*\b(setup|onboarding|task|tasks|api key|api keys|credential|credentials)\b/;
  const platformSetupPattern = /\b(configure|finish|complete)\b.*\b(platform|workspace|deployment)\b.*\b(setup|configuration|onboarding)\b/;
  const launchPausedPattern = /\b(launch paused|blocked launch|normal prompts paused|casper setup mode)\b/;
  return Boolean(
    explicitSetupAssistantPattern.test(text)
    || explicitPendingSetupPattern.test(text)
    || platformSetupPattern.test(text)
    || launchPausedPattern.test(text)
  );
}

export function onboardingCredentialOriginLabel(item = {}) {
  if (!item.configured && item.status !== "completed") return "needs setup";
  if (item.configured_by === "environment") return "ready from deployment env";
  if (item.configured_by === "key_manager") return "ready from Key Manager";
  if (item.configured_by) return `ready from ${String(item.configured_by).replace(/_/g, " ")}`;
  return "ready";
}
